import { Box, Stack } from "@mui/material";

import { useTheme } from "../ui-v2";
import { SelectionSidebarObjectInfo } from "./object-info/SelectionSidebarObjectInfo";
import { PreviewContent } from "./PreviewContent";
import { SelectionSidebarHeader } from "./SelectionSidebarHeader";
import { SelectionSidebarMainActions } from "./SelectionSidebarMainActions";
import { SelectedObject, SidebarContext } from "./types";

type SelectionSidebarProps = {
  context?: SidebarContext;
  objects: SelectedObject[];
  isGalleryOpen?: boolean;
  isShowingActions?: boolean;
  isShowingPreview?: boolean;
  isShowingInPreview?: boolean;
  isShowingObjectDetails?: boolean;
  sessionId?: string;
  onClickPreview?: (isGalleryOpen: boolean) => void;
  onCloseDialog?: () => void;
  onSaveToDrive?: () => void;
  onReloadObjects?: () => void;
  setIsCustomStyleDialogOpen?: (isOpen: boolean) => void;
};

export const SelectionSidebar = (props: SelectionSidebarProps) => {
  const theme = useTheme();

  const {
    context,
    objects,
    isGalleryOpen,
    isShowingActions,
    isShowingPreview,
    isShowingInPreview,
    isShowingObjectDetails,
    sessionId,
    onCloseDialog,
    onClickPreview,
    onReloadObjects,
  } = props;

  const firstObject = objects[0];

  if (!firstObject) {
    return null;
  }

  return (
    <Stack
      spacing={3}
      sx={{
        alignItems: "center",
        width: "100%",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          width: "100%",
          borderBottom: `1px solid ${theme.palette.secondary[6]}`,
        }}
      >
        <SelectionSidebarHeader
          objects={objects}
          context={context}
          onCloseDialog={onCloseDialog}
          onReloadObjects={onReloadObjects}
        />
      </Box>
      <Stack
        sx={{
          width: "100%",
          flexGrow: 1,
          paddingX: theme.spacing(2),
        }}
        spacing={2}
      >
        {isShowingPreview && (
          <PreviewContent
            objects={objects}
            isGalleryOpen={isGalleryOpen}
            onClickPreview={onClickPreview}
            isShowingInPreview={isShowingInPreview}
          />
        )}
        {isShowingActions && context && (
          <SelectionSidebarMainActions
            context={context}
            objects={objects}
            sessionId={sessionId}
          />
        )}
        {(isShowingObjectDetails || objects.length === 1) && (
          <SelectionSidebarObjectInfo object={firstObject} />
        )}
      </Stack>
    </Stack>
  );
};
